import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	learnMore: {
		id: 'software-cycle-time-breakdown-report.no-provider.learn-more',
		defaultMessage: 'Learn more',
		description: 'Learn more links to a page that outlines how to integrate CI/CD tools',
	},
	noProviderTitle: {
		id: 'software-cycle-time-breakdown-report.no-provider.no-provider-title',
		defaultMessage: 'Connect your source code management and CI/CD tools',
		description:
			'The title that is shown when no SCM or deployment provider is installed in this project and the user is viewing cycle time report page',
	},
	noProviderDescription: {
		id: 'software-cycle-time-breakdown-report.no-provider.no-provider-description',
		defaultMessage:
			"Based on the data from your tools, you'll see median cycle time and issues shipped to production.",
		description:
			'The description that is shown when no SCM or deployment provider is installed in this project and the user is viewing cycle time report page',
	},
});
